import { useRef } from "react"
import { useNavigate } from "react-router-dom"

import { Button, ButtonSize } from "../../../../components/Button"
import { useTextStorage, useImagePreload } from "../../../../hooks"
import "./AnimalSection.scss"

import {
  services1Bg,
  services1Hq,
  services1Lq,
  testimonialDecor as services1Decor,
} from "../../../../assets/images"

export const AnimalSection: React.FC = () => {
  const { ts } = useTextStorage()
  const navigate = useNavigate()

  const hqRef = useRef<HTMLImageElement>(null)
  useImagePreload(services1Hq, hqRef)

  const handleConnectButtonClick = () => {
    navigate("/#connect")
  }

  const handleGalleryButtonClick = () => {
    navigate("/gallery")
  }

  return (
    <div className="animal-section">
      <h2>{ts.pages.services.sections[0].title}</h2>
      <div className="animal-section--image-container">
        <img
          src={services1Bg}
          alt="animal-section-bg"
          className="animal-section--bg"
        />
        <img
          src={services1Lq}
          alt="animal-section-pic-lq"
          className="animal-section--lq"
        />
        <img
          ref={hqRef}
          src={services1Hq}
          alt="animal-section-pic-hq"
          className="animal-section--hq"
        />
        <img
          src={services1Decor}
          alt="animal-section-decor"
          className="animal-section--decor"
        />
      </div>
      <div className="animal-section--content">
        <h2>{ts.pages.services.sections[0].title}</h2>
        {ts.pages.services.sections[0].paragraphs.map((paragraph, i) => (
          <p key={`animal-section--paragraph-${i}`}>{paragraph}</p>
        ))}
        <div className="animal-section--content--buttons-container">
          <Button
            text={ts.pages.services.buttonTextConnect}
            size={ButtonSize.MD}
            onClick={handleConnectButtonClick}
          />
          <Button
            text={ts.pages.services.buttonTextGallery}
            size={ButtonSize.MD}
            onClick={handleGalleryButtonClick}
          />
        </div>
      </div>
    </div>
  )
}
